// Spinner.js
import React from 'react';
import './Spinner.css';

const Spinner = () => (
  <div className="spinner-container">
    <div className="spinner"></div>
  </div>
);

export default Spinner;
